import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import {
	getIndicatorClassificationColorClassName,
	IndicatorEmultiEnum,
} from "@/utils/indicatorsEmulti";
import { ResumeIndicatorM2Data } from "@/services/esus/indicator/emulti/m2/getResumeIndicatorM2";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEmultiM2ResumeProps = {
	resume: ResumeIndicatorM2Data;
};

export function IndicatorEmultiM2Resume({ resume }: Readonly<IndicatorEmultiM2ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalSharedAttendances,
		resume.totalAttendances
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} className="mb-2">
				<CardInformative
					title="Total de ações"
					value={resume.totalAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de ações"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Atendimentos individuais, atendimentos odontológicos e atividades
								coletivas, <br />
								compartilhadas ou não, bem como cuidados compartilhados, realizados
								no <br />
								período em que pelo menos um dos profissionais pertença a uma{" "}
								<br />
								equipe emulti.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} className="mb-2">
				<CardInformative
					title="Total de ações compartilhadas"
					value={resume.totalSharedAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de ações compartilhadas"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Atendimentos individuais, atendimentos odontológicos e atividades
								coletivas compartilhadas, bem como cuidados compartilhados, <br />
								realizados no período onde pelo menos 1 dos profissionais
								pertença a uma equipe emulti. <br />
								Em casos de atendimentos individuais, pelo menos 1 dos demais
								<br />
								profissionais devem pertencer a uma das seguintes equipes:
								<br />
								eSF - equipe da equipe Saúde da Família <br />
								eSFR - equipe Saúde da Família Ribeirinha <br />
								eCR - equipe Consultório na Rua <br />
								eAP - equipe de Atenção Primária <br />
								UBSF - equipe de Unidade Básica de Saúde Fluvial <br />
								OBS: Atendimentos individuais compartilhados entre profissionais{" "}
								<br />
								da mesma equipe emulti também serão considerados desde que sejam{" "}
								<br />
								registrados por 2 profissionais diferentes (CNS distintos).
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} className="mb-2">
				<CardInformative
					title="Total de ações não compartilhados"
					value={resume.totalNonSharedAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de ações não compartilhadas"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de Atendimentos individuais, atendimentos odontológicos e
								atividades coletivas <br />
								realizadas exclusivamente por 1 profissional de uma equipe emulti no
								período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} className="mb-2">
				<CardInformative
					title="Média de ações compartilhadas"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEmultiEnum.M2,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Média de ações compartilhadas"
							message="Percentual de ações compartilhadas em relação às não compartilhadas realizadas pela emulti no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
